export enum ContentType {
    HOME,
    ABOUT,
    PROJECTS,
    PROJECTS_PROGRAMS,
    XGEO,
    XGEO_SOON,
    XGEO_US,
    XGEO_US_ADOPT_A_HIGHWAY,
    XGEO_US_STATE_HIGHWAY,
    XGEO_US_COUNTY_SECONDARY_HIGHWAY,
    XGEO_US_STATE_FLAGS,
    XGEO_NA_ABBREVIATIONS,
    XGEO_US_WINDSHIELD_STICKERS,
    XGEO_NA_AREA_CODES,
    XGEO_NA_TREE_SPECIES,
    XGEO_BR,
    XGEO_BR_ABBREVIATIONS,
    XGEO_BR_POSTCODES,
    XGEO_EU,
    XGEO_EU_BOLLARDS,
    XGEO_EU_CHEVRONS,
    XGEO_EU_DOMAINS,
    XGEO_EU_GUARDRAILS,
    XGEO_EU_FLAGS,
    XGEO_EU_PEDESTRIAN_CROSSINGS,
    XGEO_MONG,
    XGEO_MONG_CAR_META,
    XGEO_INDONESIA_KABUPATEN,
    XGEO_PHILLIPINES_PROVINCES,
    XGEO_PHILLIPINES_REGIONS,
    XGEO_PHILLIPINES_PLATES,
    XGEO_VIETNAM_PROVINCES,
    XGEO_VIETNAM_AREA_CODES,
    XGEO_VIETNAM_LICENSE_PLATE_CODES,
    XGEO_VIETNAM_REGIONAL_PLACE_NAMES,
    XGEO_VIETNAM_POLES,
    XGEO_NIGERIA_STATES,
    XGEO_KENYA_COUNTIES,
    XGEO_AUSTRALIA_PLATES,
    XGEO_ZA_PLATES,
    XGEO_ZA_PROVINCES,
    XGEO_JP_AREACODES,
    XGEO_JP_PREFECTURES,
    XGEO_JP_POLE_PLATES,
    XGEO_JP_POLE_REFLECTORS,
    XGEO_JP_POLE_ATTACHMENTS,
    XGEO_JP_KANJI,
    XGEO_JP_REGIONS,
    SOON,
}
